export default __webpack_public_path__ + "static/media/gallery_05.3d38b2da.jpg";